import React, { useState, useRef } from 'react'
import { Link } from 'react-router-dom'
import {
  IonContent,
  useIonViewDidEnter,
  useIonViewWillLeave
} from '@ionic/react'
import { setRootMetaTags } from '../../services/metatags'
import { setView } from '../../services/analytics'
import { setPixelView } from '../../services/fbPixel'
import { Advertisement } from '../../components/common/Advertisement'
import { NewsSwipper } from '../../components/common/NewsSwipper'
import CategoriesReel from './CategoriesReel'
import SeasonalStation from './SeasonalStation'
import RadioLatestSwipper from './RadioLatestSwipper'
import HighlightedContents from './HighlightedContents'
import TopPlaylists from './TopPlaylists'
import LatestPodcast from './LatestPodcast'
import './styles.scss'

const Home = (props) => {
  const [isVisible, setIsVisible] = useState(false)
  const contentRef = useRef()

  useIonViewDidEnter(() => {
    setIsVisible(true)
    setRootMetaTags()
    setView(window.location.pathname)
    setPixelView()
  })

  useIonViewWillLeave(() => {
    setIsVisible(false)
  })

  if (isVisible === false) return null

  return (
    <IonContent
      ref={contentRef}
      fullscreen
      className='home-page page-wrapper'
    >

      <div className='center-wrapper'>

        <RadioLatestSwipper />

        <Advertisement />

        <CategoriesReel />

        <SeasonalStation />

        <section className='news-navigation'>
          <h1 className='radio-title'>Radio News</h1>
          <NewsSwipper />
          <Link
            className='like-title'
            to='/news/1'
          >
            Ver más
          </Link>
        </section>

        <h1 className='radio-title'>Lo más escuchado</h1>
        <HighlightedContents />

        <Advertisement />

        <h1 className='radio-title'>Tops Recientes</h1>
        <TopPlaylists />

        <h1 className='radio-title'>Episodios Recientes</h1>
        <LatestPodcast />

      </div>
    </IonContent>
  )
}

export default Home
